import Vue from 'vue'
import Router from 'vue-router'
import ListLayout from './layouts/ListLayout.vue'
import LoginLayout from './layouts/LoginLayout.vue'
import Home from './views/Home.vue'
import Entry from './views/Entry.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      name: 'home',
      path: '/',
      redirect: {
        name: 'list'
      }
    },
    {
      name: 'login',
      path: '/login',
      component: LoginLayout,
    },
    {
      path: '/list',
      // name: 'list',
      component: ListLayout,
      children: [
        {
          path: '',
          name: 'list',
          component: Home
        },
        {
          path: ':id',
          name: 'entry',
          component: Entry
        },
      ]
    }
  ]
})
